import React, { useRef, useEffect } from "react";
import videojs from "video.js";
import "videojs-playlist";
import "video.js/dist/video-js.css";
import "./video.css";
import { getPlaylist } from "../../api";

const AdVideo: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const player = videojs(videoRef.current, {
      autoplay: true,
      muted: true,
      controls: true,
      preload: "auto",
      controlBar: {
        volumePanel: {
          inline: false,
          volumeControl: {
            vertical: true,
          },
        },
        // @ts-ignore
        pictureInPictureToggle: false,
      },
    });

    getPlaylist().then((res: any) => {
      // @ts-ignore
      player.playlist(res);

      // @ts-ignore
      player.playlist.repeat(true);

      // @ts-ignore
      player.playlist.autoadvance(0);
    });

    return () => player.dispose();
  }, []);

  return (
    <div className="absolute px-4 pt-4 w-full h-full">
      <div
        className="p-3 h-full"
        style={{
          border: "1.8px transparent solid",
          borderImage:
            "linear-gradient(30deg, #7cc2fa 0%, transparent 30%, transparent 70%, #7cc2fa 100%) 1 1 stretch",
        }}
      >
        <div data-vjs-player>
          <video
            ref={videoRef}
            className="video-js vjs-big-play-centered vjs-fill"
          ></video>
        </div>
      </div>
    </div>
  );

  // return (
  //   <video controls muted autoPlay loop width="100%" height="100%" disablePictureInPicture controlsList="nodownload noremoteplayback">
  //     <source src="/video/a.mp4" type="video/mp4" />
  //     Sorry, your browser doesn't support embedded videos.
  //   </video>
  // );
};

export default AdVideo;
